import { render, staticRenderFns } from "./v-img.vue?vue&type=template&id=bcf8afa0"
import script from "./v-img.vue?vue&type=script&lang=js"
export * from "./v-img.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports